import '@vanilla-extract/css/vanilla.virtual.css?ve-css=Lnhlb21pdTAgewogIGRpc3BsYXk6IGZsZXg7Cn0';
import '@vanilla-extract/css/vanilla.virtual.css?ve-css=Lnhlb21pdTEgPiAqIHsKICBmbGV4LWdyb3c6IDE7Cn0';
export var flexStyle = 'xeomiu0';
export var growChildrenStyle = 'xeomiu1';